import { Link, SearchParams } from '@gogame/navigation';

import { screenSchema } from './schemas';

export const postbacksReportSearchParams = new SearchParams(screenSchema);

export const postbacksReportLink = new Link(
  'postbacks-report',
  postbacksReportSearchParams
);
